<template>
    <div class="languageHome">
        <div class="selectLanguage" @click="toggleSelect">
            <md-icon>language</md-icon>
        </div>
        <ul class="languageList" v-if="isSelectionTrue" @mouseleave="selectBlur">
            <li @click="languageSelect(lang.code)" v-for="lang in languages">
                <div class="d-flex align-items-center">
                    <country-flag
                        :style="{ borderRadius: '5px' }"
                        :class="{
                            selected: lang.code === $i18n.locale,
                        }"
                        :country="lang.code === 'en' ? 'us' : lang.code === 'ar' ? 'sa' : lang.code"
                    />
                    <div class="justify-content-end pl-3 cursorPointer popoverFont">
                        {{ lang.name }}
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import log2 from "../utils/log2";
import CountryFlag from "vue-country-flag";

const log = log2("LanguageSwitch");
export default {
    name: "LanguageSwitch",
    components: {
        CountryFlag,
    },
    data() {
        return {
            isSelectionTrue: false,
        };
    },
    computed: {
        ...mapState({
            language: (state) => state.language.language,
            languages: (state) => state.language.languages,
        }),
    },
    methods: {
        ...mapActions({
            setLanguage: "language/setLanguage",
        }),
        toggleSelect() {
            log("togle select calıştı");
            this.isSelectionTrue = !this.isSelectionTrue;
        },
        selectBlur() {
            log("selectBlur calisti");
            this.isSelectionTrue = false;
        },
        languageSelect(code) {
            this.setLanguage(code);
            this.isSelectionTrue = false;
        },
    },
};
</script>
<style lang="scss" scoped>
.languageHome {
    position: relative;
}

.selectLanguage {
    float: right;
    margin-right: 1.5rem;
    cursor: pointer;
}

.languageList {
    list-style: none;
    overflow: hidden;
    margin: 0;
    padding: 0;
    background: #fafafa;
    opacity: revert;
    color: #515173;
    display: inline-block;
    position: absolute;
    top: 30px;
    right: 20px;
    border-radius: 3px;
    z-index: 1;

    li {
        cursor: pointer;
        user-select: none;
        padding: 6px 12px;

        &:hover {
            background-color: #ed6e4d;
            color: white;
            opacity: 0.7;
        }
    }
}
</style>
